import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InputField } from "../../../../shared/ui/input-field/input-field";
import { Button } from "../../../../shared/ui/button/button";
import { Sidebar } from '../../../../core/services/sidebar';
import { Modal } from '../../../../core/services/modal';
import { Popup } from '../../../../core/services/popup';
import { Header } from '../../../../core/services/header';

@Component({
  selector: 'app-step1-company-registration',
  imports: [InputField, Button, TranslatePipe, ReactiveFormsModule, CommonModule],
  templateUrl: './step1-company-registration.html',
  styleUrl: './step1-company-registration.css'
})
export class Step1CompanyRegistration {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  isEntityNationalNumberValid = true; // handle error from backend.
  companyDetailsFetched = false;
  expandCompanyDetails = false;

  companyRegistrationForm = new FormGroup({
    entityNationalNumber: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d{9}$/)
    ]),
  });

  constructor(
    private sidebarService: Sidebar,
    private modalService: Modal,
    private popup: Popup,
    private headerService: Header
  ) { }

  ngOnInit() {
    if (this.data) this.companyRegistrationForm.patchValue(this.data);
    this.sidebarService.setLinks([
      {
        label: 'SIDEBAR.SAVE_EXIT',
        route: '/',
        iconPath: 'assets/icons/cancel-blue.svg',
        variant: 'plain',
      },
    ]);

    //Set header configs
    this.headerService.updateConfig({
      showNotifications: false,
      showRightSection: false,
      dropdownOptions: []
    });
  }

  handleFormSubmission() {
    // console.log('Form submitted!', this.companyRegistrationForm.value);
    this.companyDetailsFetched = true;
  }

  expandCompanyDetailsHandler() {
    this.expandCompanyDetails = !this.expandCompanyDetails;
  }

  moveToLicenseDetails() {
    this.next.emit();
  }

  get entityNationalNumberControl(): FormControl {
    return this.companyRegistrationForm.get('entityNationalNumber') as FormControl;
  }

}
